import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useEventOptions } from "@/hooks/useEventOptions";

export default function EventSelect({ value, onChange, includeAll = true, className }) {
  const { options } = useEventOptions();
  return (
    <Select value={value || (includeAll ? "all" : "")} onValueChange={onChange}>
      <SelectTrigger className={className || "w-full sm:w-64 bg-white rounded-full"} data-testid="event-select">
        <SelectValue placeholder="Pilih event" />
      </SelectTrigger>
      <SelectContent>
        {includeAll && <SelectItem value="all">Semua Event</SelectItem>}
        {options.map((o) => <SelectItem key={o.value} value={o.value}>{o.label}</SelectItem>)}
      </SelectContent>
    </Select>
  );
}
